module.exports = __webpack_public_path__ + "static/media/outro-img.9ecd431b.svg";